import { EntityWithStatusService } from './EntityWithStatusService';
import { IEntityChildren, IEntityDescription1, IApp04AIChat } from '../types';
import { EntityStatus } from '../refData/EntityStatus';
import { AppGlobals } from '../AppGlobals';

export class App04AIChatService extends EntityWithStatusService<IApp04AIChat> {
    private apiURL: string;
    //public readonly parentEntities = ['ManagedByL2', 'ManagedByL3'];
    protected childrenEntities = ['App04AIChatUsers($expand=User)'];

    constructor() {
        super(`/App04AIChats`);
        const apiURL = process.env.REACT_APP_ZedX_API!;
        this.apiURL = apiURL;
    }

    public async clearChatMessages(payload: {
        ChatID: number;
    }): Promise<void> {
        await this.axiosPost(`${this.apiURL}/ClearChatMessages`, payload);
    }

    public readAllForList(includeClosed?: boolean, topicID?: number, appID?: number): Promise<IApp04AIChat[]> {
        return this.readAll(
            `?$select=ID,Title,LastPrompt,TotalPrompts,CreatedOn,LastPromptAt`
            + `&$orderby=ID desc`
            + `&$expand=`
            + `App04AIChatUsers($select=ID;$expand=User($select=Title)),`
            + `App04AIChatMessages($select=ID)`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
            + (topicID ? ` and TopicID eq ${topicID}` : ``)
            + (appID ? ` and AppID eq ${appID}` : ``)
        );
    }

    public readAllChatsForCounters(includeClosed?: boolean): Promise<IApp04AIChat[]> {
        return this.readAll(
            `?$select=ID,TopicID`
            + `&$orderby=ID`
            + `&$expand=App04AIChatUsers($select=UserID)`
            + (includeClosed ? `` : ` &$filter=EntityStatusID eq ${EntityStatus.Open}`)
        );
    }


}